define('controllers/basket',['require','controllers/base/controller','views/pages/basket/index','models/pages/basket/index'],function(require) {
    'use strict';

    var Controller = require('controllers/base/controller'),
        BasketPageView = require('views/pages/basket/index'),
        BasketPageModel = require('models/pages/basket/index');

    var BasketController = Controller.extend({
        show: function() {
            var model = new BasketPageModel({
            });

            this.view = new BasketPageView({
                model: model
            });

            model.load(true);
        }
    });

    return BasketController;
});

